module.exports = __webpack_public_path__ + "static/media/opensans-bold.891df715.woff";